// Auto generated file, do not manually modify!
// com.hotpads.leasing.client.enums.AdditionalRequest

export enum AdditionalRequest {
  FIRST_MONTH_REDUCED_RENT_15 = 'FIRST_MONTH_REDUCED_RENT_15',
  OTHER = 'OTHER',
  PROFESSIONAL_CLEANING = 'PROFESSIONAL_CLEANING',
  UPGRADE_APPLIANCE = 'UPGRADE_APPLIANCE',
  WAIVE_LATE_FEE = 'WAIVE_LATE_FEE',
  YARD_MAINTENANCE = 'YARD_MAINTENANCE',
}

export const AdditionalRequest_values = [
  AdditionalRequest.FIRST_MONTH_REDUCED_RENT_15,
  AdditionalRequest.OTHER,
  AdditionalRequest.PROFESSIONAL_CLEANING,
  AdditionalRequest.UPGRADE_APPLIANCE,
  AdditionalRequest.WAIVE_LATE_FEE,
  AdditionalRequest.YARD_MAINTENANCE,
] as const;
